import { __awaiter, __generator } from "tslib";
import { PageMap } from '@wix/wixstores-client-core';
import { MinicartActions } from '../../../actions/MiniCartActions/MinicartActions';
import { TinyCartActions } from '../../../actions/TinyCartActions/TinyCartActions';
import { SideCartActions } from '../../../actions/SideCartActions/SideCartActions';
import { intToGuid } from '../../../utils/intToGuid';
import { getLeanGQLCartFromCartV1 } from '../../current-cart-service/getLeanGQLCartFromCartV1';
import { loadMiniCartIfNotLoaded } from '../../../utils/miniCart.utils';
export function createCartExports(_a) {
    var _this = this;
    var context = _a.context, origin = _a.origin;
    var getMiniCartActions = function (siteStore) { return new MinicartActions({ siteStore: siteStore, origin: origin }); };
    var getSideCartActions = function (siteStore) { return new SideCartActions({ siteStore: siteStore, origin: origin }); };
    var getTinyCartActions = function (siteStore) { return new TinyCartActions({ siteStore: siteStore, origin: origin, context: context }); };
    var hideMiniCart = function () {
        if (context.siteStore.isMobile()) {
            throw Error("can't handle mini cart in mobile");
        }
        getMiniCartActions(context.siteStore).hideMinicart();
    };
    var openSideCartOrMiniCart = function (options) {
        if (options === void 0) { options = { allowShowingSideCartOnMobile: false }; }
        return __awaiter(_this, void 0, void 0, function () {
            var sideCartActions;
            return __generator(this, function (_a) {
                sideCartActions = getSideCartActions(context.siteStore);
                return [2 /*return*/, sideCartActions.showMiniCartOrSideCart(options)];
            });
        });
    };
    return {
        getCurrentCart: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getLeanGQLCartFromCartV1(context.currentCartService)];
            });
        }); },
        onChange: function (listener) {
            return context.currentCartService.onChange(listener);
        },
        removeProduct: function (cartItemId, _options) {
            if (_options === void 0) { _options = { silent: false }; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, context.currentCartService.removeLineItemV1({ lineItemId: intToGuid(Number(cartItemId)) }, { origin: origin })];
                });
            });
        },
        /**
         * @deprecated. use add to current cart via sdk
         */
        addToCurrentCart: function (options) {
            return context.currentCartService.addToCurrentCartV1(options);
        },
        /**
         * @deprecated. use add to current cart via sdk
         */
        addLineItemsToCurrentCart: function (options) {
            return context.currentCartService.addToCurrentCartV1({ lineItems: options.catalogItems });
        },
        applyCoupon: function (couponCode) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, context.currentCartService.applyCouponV1({ code: couponCode }, { origin: origin })];
            });
        }); },
        removeCoupon: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, context.currentCartService.removeCouponV1({ origin: origin })];
            });
        }); },
        updateLineItemQuantity: function (cartItemId, quantity, _options) {
            if (_options === void 0) { _options = { silent: false }; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, context.currentCartService.updateLineItemQuantityV1({ lineItemId: intToGuid(cartItemId), quantity: quantity }, { origin: origin })];
                });
            });
        },
        showMinicart: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, openSideCartOrMiniCart()];
        }); }); },
        hideMinicart: hideMiniCart,
        openSideCart: function (options) {
            if (options === void 0) { options = { allowShowingSideCartOnMobile: false }; }
            return openSideCartOrMiniCart(options);
        },
        showTinycart: function (options) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (context.siteStore.isMobile()) {
                            throw Error("can't open success popup in mobile");
                        }
                        return [4 /*yield*/, loadMiniCartIfNotLoaded(context)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, getTinyCartActions(context.siteStore).showTinyCart(options)];
                }
            });
        }); },
        hideTinycart: function () {
            if (context.siteStore.isMobile()) {
                throw Error("can't open success popup in mobile");
            }
            getTinyCartActions(context.siteStore).hideTinyCart();
        },
        reloadCart: function () {
            return context.currentCartService.invalidateAndReload();
        },
        hasSideCart: function () { return getSideCartActions(context.siteStore).hasSideCart(); },
        hasCartIcon: function () { return Promise.resolve(context.siteStore.isCartIconExists); },
        preloadTinyCart: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, loadMiniCartIfNotLoaded(context)];
            });
        }); },
        preloadSideCart: function () { return __awaiter(_this, void 0, void 0, function () {
            var sideCartActions, sideCartName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sideCartActions = getSideCartActions(context.siteStore);
                        return [4 /*yield*/, sideCartActions.getSideCartName()];
                    case 1:
                        sideCartName = _a.sent();
                        if (!sideCartName) {
                            return [2 /*return*/];
                        }
                        context.siteStore.siteApis.prefetchPageResources({
                            lightboxes: [sideCartName],
                        });
                        return [2 /*return*/];
                }
            });
        }); },
        preloadCartPage: function () { return __awaiter(_this, void 0, void 0, function () {
            var sectionUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, context.siteStore.getSectionUrl(PageMap.CART)];
                    case 1:
                        sectionUrl = _a.sent();
                        if (sectionUrl.relativeUrl) {
                            context.siteStore.siteApis.prefetchPageResources({ pages: [sectionUrl.relativeUrl] });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('failed to prefetch cart page', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    };
}
//# sourceMappingURL=wixcode.cart.js.map